import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// @mui material components
import { Tab, Tabs, Grid, Card } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';

import UsersReportsTab from './components/UsersReportsTab';
import TabPanel from 'components/TabPanel/TabPanel';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const UserReports = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState('users-acquired');

  const handleChange = (event, newValue) => {
    handleTabSelect(newValue);
  };

  const handleTabSelect = (tabKey) => {
    switch (tabKey) {
      case 'users-acquired':
        navigate(
          {
            hash: 'users-acquired',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'users-by-state':
        navigate(
          {
            hash: 'users-by-state',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'users-by-age':
        navigate(
          {
            hash: 'users-by-age',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      default:
        navigate(
          {
            hash: 'users-acquired',
          },
          { replace: true }
        );
        setValue('users-acquired');
        break;
    }
  };

  useEffect(() => {
    if (location.hash === '') {
      navigate(
        {
          hash: 'users-acquired',
        },
        { replace: true }
      );
    } else {
      handleTabSelect(location.hash?.replace('#', ''));
    }
  }, [location.hash]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="Users Reports"
              >
                <Tab
                  label="New Users Acquired"
                  value={'users-acquired'}
                  {...a11yProps(0)}
                />
                <Tab
                  value={'users-by-state'}
                  label="Users by State"
                  {...a11yProps(1)}
                />
                <Tab
                  value={'users-by-age'}
                  label="Users by Age Groups"
                  {...a11yProps(2)}
                />
              </Tabs>
            </MDBox>
            <TabPanel value={value} index={'users-acquired'}>
              <UsersReportsTab reportType={'users-acquired'} />
            </TabPanel>

            <TabPanel value={value} index={'users-by-state'}>
              <UsersReportsTab reportType={'users-by-state'} />
            </TabPanel>

            <TabPanel value={value} index={'users-by-age'}>
              <UsersReportsTab reportType={'users-by-age'} />
            </TabPanel>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default UserReports;
